import {
  BetslipCategory,
  BetslipState,
  BetslipSettingsMap,
  BetslipStakesMap,
  BetslipBoostMap,
  BetslipRules,
} from "./betslipTypes";

const betslipCategories = Object.values(BetslipCategory);

const betslipInitialRules: BetslipRules = {
  allowSameEventSelections: false,
  // Permissive until the real rules land: the store is read for one render
  // before useUserBettingRules resolves, and a false here would flash a
  // "not allowed" warning at every player.
  mixLiveAndLineEnabled: true,
  basketballMixLiveAndLineEnabled: true,
  mixFootballAndBasketballEnabled: true,
  mixVirtualFootballAndOthersEnabled: true,
  mixVirtualBasketballAndOthersEnabled: true,
  maxTotalOdds: 1000,
  combinationInsuranceEnabled: false,
  combinationBoostEnabled: false,
  systemBetsEnabled: false,
  minStakeAmount: 0,
  maxStakeAmount: 0,
  maxPayoutAmount: 0,
  lineMinOdds: 0,
  lineMaxOdds: 0,
  liveMinOdds: 0,
  liveMaxOdds: 0,
  liveBettingDelaySeconds: 0,
  oddsChangeAllowed: true,
  couponCancelWindowMinutes: 0,
};

const betslipInitialSettingsMap: BetslipSettingsMap = {
  single: { minSelectionsCount: 1, maxSelectionsCount: 20 },
  combination: { minSelectionsCount: 2, maxSelectionsCount: 20 },
  system: { minSelectionsCount: 3, maxSelectionsCount: 8 },
};

const betslipInitialStakesMap: BetslipStakesMap = {
  combination: {},
  single: {},
  system: {},
};

const betslipInitialBoostMap: BetslipBoostMap = {
  combination: undefined,
  single: undefined,
  system: undefined,
};

const betslipInitState: BetslipState = {
  ownerUserId: null,
  isLocked: false,
  rules: betslipInitialRules,
  settingsMap: betslipInitialSettingsMap,
  stakesMap: betslipInitialStakesMap,
  boostMap: betslipInitialBoostMap,
  systemComboStake: "",
  category: BetslipCategory.Single,
  selectionMap: {},
  selections: [],
  originalOddsMap: {},
  eventsMap: {},
  events: [],
  selectionsByEvent: {},
  selectionsByMarket: {},
  name: "",
  error: null,
  placementError: null,
  lastActivityTime: Date.now(),
};

export {
  betslipCategories,
  betslipInitialStakesMap,
  betslipInitialSettingsMap,
  betslipInitState,
};
